import {
  legacy_createStore as createStore,
  applyMiddleware,
  combineReducers,
  AnyAction,
  Action,
} from "redux";
import thunk, { ThunkAction, ThunkDispatch, ThunkMiddleware } from "redux-thunk";
import storage from "redux-persist/lib/storage";
import { createLogger } from "redux-logger";
import { persistStore, persistReducer } from "redux-persist";
import { ReducerDataUser, ReducerEmailValidation, ReducerRegisterUser, ReducerloginUser } from "./Reducer/ReducerUser";
import { ReducerCategoryCampaign, ReducerIdCampaign, ReducerPriorityCampign, ReducerRegisCampaign } from "./Reducer/ReducerCampaign";
import { ReducerAttendInvitation, ReducerCancelCampaign, ReducerImageTracker, ReducerListExperience, ReducerListInvitation, ReducerListInvitationAttend, ReducerReview, ReducerReviewForm, ReducerUpdatePassword, ReducerUpdateProfile } from "./Reducer/ReducerMypage";
import { ReducerAllBanner } from "./Reducer/ReducerBanner";

const rootReducer = combineReducers({
  ReducerListInvitationAttend,
  ReducerDataUser,
  ReducerRegisterUser,
  ReducerloginUser,
  ReducerPriorityCampign,
  ReducerIdCampaign,
  ReducerRegisCampaign,
  ReducerListExperience,
  ReducerListInvitation,
  ReducerAttendInvitation,
  ReducerReviewForm,
  ReducerReview,
  ReducerAllBanner,
  ReducerCategoryCampaign,
  ReducerImageTracker,
  ReducerCancelCampaign,
  ReducerUpdateProfile,
  ReducerUpdatePassword,
  ReducerEmailValidation
});

const persistConfig = {
  key: "root",
  storage,
};

const logger = createLogger();
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(persistedReducer, applyMiddleware(thunk as ThunkMiddleware<RootState, AnyAction>, logger));
const persistor = persistStore(store);

export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;
export type RootState = ReturnType<typeof rootReducer>;
export { store, persistor };
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

import { useDispatch } from "react-redux";
export const useAppDispatch = () => useDispatch<AppDispatch>();